export default [
  '#176DB6',
  '#5A91C0',
  '#A4C2D5',
  '#9B9B9B',
  '#777777',
  '#171717',
];
